export const config = {
  title: "Diggs Lawncare and Handyman, LLC | Conway, SC",
  meta: {
    description:
      "Diggs Lawncare and Handyman, LLC provides professional lawn care, landscaping, and handyman services in Conway, SC and surrounding areas. Reliable, affordable, and customer-focused.",
    keywords: [
      "Diggs Lawncare and Handyman",
      "lawn care Conway SC",
      "landscaping Conway SC",
      "handyman Conway SC",
      "home repairs Conway",
      "yard maintenance",
      "garden care",
      "SC lawn services"
    ],
    author: "Diggs Lawncare and Handyman, LLC",
    canonicalUrl: "https://www.facebook.com/61580979441413/",
  },
  sections: {
    header: {
      businessName: "Diggs Lawncare and Handyman, LLC",
    },
    sectionB: {
      heroTitle: "Lawncare & Handyman Services You Can Trust",
      heroSubtitle: "Serving Conway, SC with reliable lawn and home solutions.",
      learnAboutText: "Explore Our Services",
      phoneNumber: "8542781774",
      phoneLabel: "(854) 278-1774",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2164422787/photo/directly-above-shot-of-man-using-lawn-mower.jpg?s=612x612&w=0&k=20&c=4RUmMIJHjd5WvBI8OV-rIwE732HM5anQGMGbNtIxLZM=", 
      cardData: [
        {
          title: "Lawncare & Maintenance",
          description:
            "Keep your yard healthy and beautiful with mowing, trimming, and regular maintenance.",
        },
        {
          title: "Landscaping",
          description:
            "From planting to design, we create and maintain outdoor spaces you’ll love.",
        },
        {
          title: "Handyman Services",
          description:
            "Reliable home repair and improvement services tailored to your needs.",
        },
      ],
      description:
        "Diggs Lawncare and Handyman, LLC offers complete lawn care, landscaping, and handyman services to help homeowners in Conway, SC keep their homes and yards in top condition.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We offer a wide range of lawncare, landscaping, and handyman services for both residential and commercial clients.",
      cards: [
        {
          title: "Lawncare & Yard Maintenance",
          description:
            "Professional mowing, trimming, and seasonal upkeep for a well-kept yard.",
          imageSrc: "https://media.istockphoto.com/id/2150853972/photo/green-grass-cutting-with-lawn-mower-in-home-garden.jpg?s=612x612&w=0&k=20&c=EzSmAvWSwnbVbJxJP6fsMIDbGnPDmJ_VgpBUVUbO1aM=",
          imageAlt: "Lawncare Service",
        },
        {
          title: "Landscaping",
          description:
            "Custom landscaping, planting, and outdoor design for beautiful spaces.",
          imageSrc: "https://media.istockphoto.com/id/2165553780/photo/low-angle-view-of-a-latino-man-spreading-soil-conditioner-from-a-bag-while-planting-a.jpg?s=612x612&w=0&k=20&c=iitV8Ngq2Sde21QWdqxgpCgTmQ62UeEjNE2dhuSQc9I=",
          imageAlt: "Landscaping Service",
        },
        {
          title: "Handyman Services",
          description:
            "General home repairs and handyman solutions at affordable rates.",
          imageSrc: "https://media.istockphoto.com/id/2168175357/photo/man-in-blue-overalls-is-carefully-adjusting-a-lawn-mower-blade-and-cleaning-while-kneeling-on.jpg?s=612x612&w=0&k=20&c=nm1YtHmLl1-rY9iWKTIQhydNlBYqk23-SP6RJLfOjxI=",
          imageAlt: "Handyman Service",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "Yard Cleanup",
        "Seasonal Maintenance",
        "Garden Care",
        "Outdoor Repairs",
        "Painting & Small Fixes",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://media.istockphoto.com/id/2165553766/photo/young-hispanic-latino-man-using-a-hand-shovel-to-dig-holes-in-soil-for-a-flowerbed-in-a.jpg?s=612x612&w=0&k=20&c=kBzVQvpnzk_rxQgh9s1ae0579ibheY3uEIEj3OLLCbc=",
        alt: "Diggs Lawncare and Handyman Team",
      },
      aboutText: [
        "At Diggs Lawncare and Handyman, LLC, we pride ourselves on delivering professional lawncare, landscaping, and handyman services that make your property shine.",
        "Based in Conway, SC, we’re committed to providing affordable, dependable, and customer-focused service for all your outdoor and home maintenance needs.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Diggs Lawncare and Handyman Logo",
      businessName: "Diggs Lawncare and Handyman, LLC",
      contact: {
        phone: "8542781774",
        phoneLabel: "(854) 278-1774",
        email: "diggslawncareandhandyman@gmail.com",
        website: "https://www.facebook.com/61580979441413/",
        address: "Conway, SC 29527",
      },
      socialMedia: {
        facebook: "https://www.facebook.com/61580979441413/",
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: "Conway, SC 29527",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3385.568!2d-79.0489!3d33.8360!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f8a1533cce7b87%3A0x7f8bbdf12345!2sConway%2C%20SC%2029527!5e0!3m2!1sen!2sus!4v1714567890123!5m2!1sen!2sus",
    },
  },
};

export default config;
